function ProcessDynamicsForm(formElement) {
    if (formElement.id || formElement.name) {
        const dynamicsWrapper = document.getElementById('dynamics-form');

        var sfForm = formElement.name ? document.getElementsByName(formElement.name)[0] : document.getElementById(formElement.id);
        var formData = {};

        for (let i = 0; i < sfForm.elements.length; i++) {
            var el = sfForm.elements[i];

            if (el.type == "tel" && el.value.indexOf('+') != 0) {
                formData[el.name] = '+' + el.value;
            }
            else if (el.name && el.name !== 'g-recaptcha-response' && !(el.type === "checkbox" && el.checked === false)) {
                formData[el.name] = el.value;
            }
        }

        if (Object.keys(formData).length) {
            var mdForm = $(dynamicsWrapper).find('form')[0];

            for (let i = 0; i < mdForm.elements.length; i++) {
                var el = mdForm.elements[i];

                if (el.id && el.name && formData[el.name]) {
                    var field = document.getElementById(el.id);
                    field.value = formData[el.name];
                }
            }


            var formSubmit = $(mdForm).find('button')[0];
            formSubmit.click();
        }

    return true;
}
}

function disableButton(button) {
    button.prop('disabled', true);
}

function hideLoader(buttonArray) {
    const button = buttonArray[0];

    button?.classList.remove("hidden")
    button?.nextElementSibling?.classList.add("hidden");
}

function showLoader(buttonArray) {
    const button = buttonArray[0];

    button?.classList.add("hidden");
    button?.nextElementSibling?.classList.remove("hidden")
}

function delayedSubmit(event, ms) {
    setTimeout(function () {
        event.target.submit();
        console.info('form submitted');
    }, ms);
};

(function ($) {
    $('button[type="submit"][sf-role="form-submit"]').each(function () {
        var $form = $(this).closest('form');
        $form.submit(function (ev) {
            if (!ev.isDefaultPrevented()) {
                ev.preventDefault();
                var button = $(this).find('button[type="submit"]');
                var recaptchaWidget = this.querySelector("[data-sf-role='recaptcha-field']");
                $form.addClass('submitting_in_progress');
                if (recaptchaWidget && grecaptcha) {
                    try {
                        var response = grecaptcha.getResponse(window[recaptchaWidget.id]);
                        if (response) {
                            if (typeof ProcessDynamicsForm === 'function') {
                                $(recaptchaWidget.nextElementSibling).addClass("hidden");
                                showLoader(button)
                                $.when(ProcessDynamicsForm(this))
                                    .done(function () {
                                        delayedSubmit(ev, 2500);
                                        hideLoader(button);
                                    });
                            } else {
                                disableButton(button);
                            }
                        }
                        else {
                            recaptchaWidget.nextElementSibling.classList.remove("hidden");
                            $form.removeClass('submitting_in_progress');
                        }
                    } catch (e) {
                        delayedSubmit(ev, 2500);
                        hideLoader(button);
                        disableButton(button);
                        return false;
                    }
                }
                else {
                    showLoader(button)
                    $.when(ProcessDynamicsForm(this))
                        .done(function () {
                            delayedSubmit(ev, 2500);
                            $(button).removeClass("hidden").next().addClass("hidden");
                        });
                }
            }
        });
    });
}(jQuery));